import { io, type Socket } from 'socket.io-client';
import { config } from '@/config/env';
import { getAccessToken } from './axios';

let socket: Socket | null = null;

/** Returns a lazily-created, authenticated Socket.IO client (singleton). */
export function getSocket(): Socket {
  if (socket) return socket;
  socket = io(config.socketUrl, {
    autoConnect: false,
    transports: ['websocket'],
    auth: { token: getAccessToken() ?? undefined },
  });
  return socket;
}

export function connectSocket(): Socket {
  const s = getSocket();
  // refresh auth token on each (re)connect
  s.auth = { token: getAccessToken() ?? undefined };
  if (!s.connected) s.connect();
  return s;
}

export function disconnectSocket(): void {
  socket?.disconnect();
}
